import { createFileRoute } from "@tanstack/react-router";
import SaintTreatmentWeek from "@/pages/SaintTreatmentWeek";
export const Route = createFileRoute("/saint-treatment-week")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "SAINT® Treatment Week: Day-by-Day Guide | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "What a week of SAINT® TMS treatment is like at Neuro Wellness in Coral Springs, FL. Consultation, fMRI, Day 1–5, what happens between sessions, follow-up.",
        },
        {
          property: "og:title",
          content: "SAINT® Treatment Week: Day-by-Day Guide | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "What a week of SAINT® TMS treatment is like at Neuro Wellness in Coral Springs, FL. Consultation, fMRI, Day 1–5, what happens between sessions, follow-up.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/saint-treatment-week",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/saint-treatment-week",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SaintTreatmentWeek />;
}
